import * as L from "leaflet";
import { LatLng, computeArea } from "spherical-geometry-js";

let polygonIs = false;

export const getCoordinates = (layer) => {
  const feature = layer.toGeoJSON();
  let coordinates = feature.geometry.coordinates[0];
  return coordinates;
};

export const setPopup = (
  coordinates,
  setPolygonData,
) => {

  const newCoordinates = coordinates.map(
    (coor) => new LatLng(coor[1], coor[0])
  );
  newCoordinates.pop();

  const area = computeArea(newCoordinates);
  const areaHectare = (area / 10000).toFixed(1);
  const popUpContent = `${areaHectare} هکتار`;

  let pol = coordinates.map((coor) => [coor[1], coor[0]]);
  var poly = new L.Polygon(pol);
  var polygonCenter = poly.getBounds().getCenter();

  const popupElement = document.getElementById("popup");
  popupElement.setAttribute("style", "display:flex");
  popupElement.childNodes[0].textContent = popUpContent;


  if(setPolygonData) {
    setPolygonData({
      polygon: newCoordinates,
      centerCoordinates: [polygonCenter?.lat, polygonCenter?.lng],
      area: areaHectare,
    });
  }
};

// export const processData = (map, setMapData, data) => {
//   if (!polygonIs) {
//     map.pm.Toolbar.setButtonDisabled("drawPolygon", true);
//     map.pm.Toolbar.setButtonDisabled("removalMode", true);

//     const fromPolygon = data((coor) => [coor[1], coor[0]]);

//     const geoJson = {
//       type: "Feature",
//       properties: {},
//       geometry: {
//         type: "Polygon",
//         coordinates: [fromPolygon],
//       },
//     };

//     const polygon = L.geoJSON(geoJson).addTo(map);

//     map.fitBounds(polygon.getBounds());

//     map.pm.enableGlobalEditMode("Polygon", {
//       snappable: true,
//       allowSelfIntersection: false,

//       editable: true,
//       templineStyle: { color: "red" },
//       hintlineStyle: { color: "red", dashArray: [5, 5] },
//     });

//     map.pm.setGlobalOptions({
//       pinning: true,
//       allowSelfIntersection: false,
//       allowSelfIntersectionEdit: false,
//       snappable: false,
//       pmIgnore: false,
//     });

//     map.pm.getGeomanLayers()?.map((layer, index) => {
//       layer.setStyle({ pmIgnore: false });
//       layer.pm.enable({
//         pinning: true,
//         allowIntersection: false,
//         snappable: false,
//       });
//       layer.on("pm:edit", (e) => {
//         const drawPolygans = map.pm.getGeomanLayers(true).toGeoJSON()
//           .features[0].geometry.coordinates[0];

//         setPopup(drawPolygans, setMapData);
//       });
//     });

//     polygonIs = true;
//   }
// };
